import type { HelpFile } from '../../types/help'
import { RolesTestIds } from '../../../testids/RolesTestIds'

export const rolesHelp: HelpFile = {
  docPage: '/docs/access/roles',
  texts: {
    [RolesTestIds.rolesList]:
      'Every role defined in the system. A role bundles related access profiles into a single composite right that fits a job function or persona.',
    [RolesTestIds.createRoleButton]:
      'Open the create-role dialog to define a new role and the access profiles it bundles.',
    [RolesTestIds.createRoleDialogTitle]:
      'Define a new role: pick a name, a description, and the access profiles to bundle.',
    [RolesTestIds.roleKeyInput]:
      'Stable kebab-case key (e.g. iam-admin) the OAuth claim mapping looks up. Read-only after create; pick something the IdP team can emit verbatim.',
    [RolesTestIds.roleNameInput]:
      'Short human-readable name — appears in pickers and on grants, so keep it concrete (e.g. "HR Recruiter" rather than "Role 7").',
    [RolesTestIds.roleDescriptionInput]:
      'Free-form description shown to approvers and auditors — record why the role exists and which job function it fits.',
    [RolesTestIds.roleKeyError]:
      'The key must be kebab-case ASCII (e.g. iam-admin), at most 64 characters. The OAuth-claim mapping looks up roles by this key.',
  },
}
